import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const query = gql`
mutation updateMyFirstName($firstName: String!) {
    updateMyFirstName(firstName: $firstName) 
},
`;

export default async function updateMyFirstName(firstName: string) {
    const variables: OperationVariables = {
        firstName,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
